import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import logoImage from '../static/logo.svg';
import profileIcon from '../static/icons/profile.svg';
import homeIcon from '../static/icons/home.svg';

class Header extends Component {
  render() {
    const { props } = this;
    return (
      <header>
        <div className="container">
            <Link to="/" id="logo">
                <img src={logoImage} alt="LandmarksID"/>
            </Link>
            {props.account ? (
              <div className="navbar-right">
                <ul className="top-nav">
                  <li><Link to="/" style={{ fontSize: '0.95rem' }}>
                    <img src={homeIcon} style={{ marginRight: 16 }}/> Back Home</Link>
                  </li>
                  <li>
                    <Link to="/" style={{ fontSize: '1.1rem' }}>Welcome {props.account.firstName}<img src={profileIcon} style={{ marginLeft: 16 }}/></Link>
                  </li>
                </ul>
              </div>
            ) : null}
        </div>
      </header>
    );
  }
}

Header.propTypes = {
  showNav: PropTypes.bool,
  account: PropTypes.object,
};

Header.defaultProps = {
  showNav: true,
}


// Map props to the store

const mapStateToProps = (state) => {
  console.log(state.accounts.get('current'));
  return {
    account: state.accounts.get('current'),
  }
};

const mapDispatchToProps = (dispatch) => ({
  
})

const HeaderContainer = connect(mapStateToProps,mapDispatchToProps)(Header);

export default HeaderContainer;



// WEBPACK FOOTER //
// ./src/shared/components/Header.js